import React, { useState, Fragment } from 'react';
import styled from 'styled-components';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const HomePageEditorWrapper = styled.div`
  margin-bottom: 50px;

  .quill {
    width: 800px;
    margin: auto;
  }

  .ql-container {
    height: 300px;
  }
`;

const modules = {
  toolbar: [
    [{ header: '1' }, { header: '2' }, { font: [] }],
    [{ size: [] }],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    // [{ 'align': ['left', 'right', 'center']}], // come back to this plz
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' },
    ],
    ['link', 'image', 'video'],
    ['clean'],
  ],
  clipboard: {
    // toggle to add extra line breaks when pasting HTML:
    matchVisual: false,
  },
};
/*
 * Quill editor formats
 * See https://quilljs.com/docs/formats/
 */
const formats = [
  'header',
  'font',
  'size',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'link',
  'image',
  'video',
];

const HomePageEditor = () => {
  const [text, setText] = useState('');

  return (
    <Fragment>
      <HomePageEditorWrapper>
        <h2>Home Page Upcoming Meeting Text</h2>
        <ReactQuill
          value={text}
          onChange={setText}
          theme="snow"
          modules={modules}
          formats={formats}
        />
      </HomePageEditorWrapper>
      <h4>Home Page Preview</h4>
      <div
        dangerouslySetInnerHTML={{
          __html: text,
        }}
      />
    </Fragment>
  );
};

export default HomePageEditor;



// WEBPACK FOOTER //
// ./src/Components/Tools/HomePageEdit.js